module.exports = __webpack_public_path__ + "img/Rainbow-mobile.f089b59e.png";